import React, {useRef, useEffect, useState} from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import {HeaderStyle, TextStyle} from '../assets/css/Styles';
import EachHeaderText from './EachHeaderText';
import '../assets/css/Animations.css';

/**
 *
 * @param {Object} props - props for the header component
 * @return {Component} header component
 */
export default function Header({...props}) {
  const [showBrand, setShowBrand] = useState(false);
  const headerRef = useRef();
  /**
   * monitor scroll event in the browser window
   */
  useEffect(() => {
    window.addEventListener('scroll', (scrollEvent) => {
      const holdCurrentRef = headerRef.current;
      // update only once after it scrolls up or down
      // from the topmost edge of the browser
      if (window.scrollY > 10 &&
        holdCurrentRef.style.backgroundColor !== 'rgba(181, 23, 158, 1)') {
        holdCurrentRef.style.backgroundColor = 'rgba(181, 23, 158, 1)';
        holdCurrentRef.style.borderBottom = '5px solid #F72585';
      } else if (window.scrollY <= 10) {
        holdCurrentRef.style.backgroundColor = 'rgba(181, 23, 158, 0)';
        holdCurrentRef.style.borderBottom = '0px solid #F72585';
      }
      // show the brand name after scrolling past the header background image
      if (window.scrollY > window.innerHeight && !showBrand) {
        setShowBrand(true);
      } else if (window.scrollY <= window.innerHeight) {
        setShowBrand(false);
      }
    });
  }, []);

  return (
    <Navbar
      expand='lg'
      collapseOnSelect
      style={HeaderStyle.headerContainer}
      ref={headerRef}>
      {
        showBrand &&
          (<Navbar.Brand id='header-brand' style={HeaderStyle.headerBrandStyle}>
            <span style={TextStyle.subTitleTxt1}>GYIMAH CLEMENT</span>
          </Navbar.Brand>)

      }
      <Navbar.Toggle
        aria-controls='responsive-navbar-nav' style={HeaderStyle.toggleStyle} />
      <Navbar.Collapse
        id='responsive-navbar-nav'>
        <Nav className='mr-auto'>
          <Nav.Link
            onClick={() => props.scrollToAboutMe()}>
            <EachHeaderText headerLinkName='ABOUT ME' />
          </Nav.Link>
          <Nav.Link onClick={() => props.scrollToProjects()}>
            <EachHeaderText headerLinkName='PROJECTS' />
          </Nav.Link>
          {/* <Nav.Link onClick={()=> null}>Experience</Nav.Link>*/}
          <Nav.Link onClick={() => props.scrollToBlog()}>
            <EachHeaderText headerLinkName='BLOG' />
          </Nav.Link>
          <Nav.Link onClick={() => props.scrollToHobbies()}>
            <EachHeaderText headerLinkName='HOBBIES' />
          </Nav.Link>
          <Nav.Link onClick={() => props.scrollToContact()}>
            <EachHeaderText headerLinkName='CONTACT' />
          </Nav.Link>
          <Nav.Link onClick={() => props.scrollToFooter()}>
            <EachHeaderText headerLinkName='GET IN TOUCH' />
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
